import React from "react";
import PropTypes from "prop-types";
import { Box } from "orcs-design-system";
import { useLocation } from "react-router-dom";
import useTimeout from "../../hooks/useTimeout";

const TEN_MINUTES = 600000;

const LoadingPage = ({
  timeout = parseInt(process.env.REACT_APP_LOADING_DEFAULT_TIMEOUT, 10) ||
    TEN_MINUTES,
  waitingFor = "unknown page",
  children,
} = {}) => {
  const location = useLocation();

  useTimeout(() => {
    throw new Error(
      `timed out after ${timeout} millisecs, loading: '${waitingFor}', path: '${location.pathname}'`
    );
  }, timeout);

  if (children) {
    return children;
  }

  return <Box data-testid="page-loader" width="100%" py="xxl" />;
};

LoadingPage.propTypes = {
  timeout: PropTypes.number,
  waitingFor: PropTypes.string,
  children: PropTypes.node,
};

export default LoadingPage;
